/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, signal, ViewEncapsulation, WritableSignal } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DragHandleComponent } from 'src/app/shared/drag-handle/drag-handle.component';
import { animate, style, transition, trigger } from '@angular/animations';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { Stamp, StampPayload } from '../interfaces/stamp.interface';
import { PassportService } from '../service/passport.service';
import { Router } from '@angular/router';
// import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
  selector: "app-passport-add-stamp",
  imports: [
    CommonModule,
    TranslateModule,
    DragHandleComponent,
    // LottieComponent,
    ZXingScannerModule
  ],  
  standalone: true,
  animations: [
    trigger('fadeOut', [
      transition(':leave', [
        style({
          height: '*',
          opacity: 1,
          marginTop: '*',
          marginBottom: '*',
          paddingTop: '*',
          paddingBottom: '*'
        }),
        animate(
          '250ms cubic-bezier(0.4, 0, 0.2, 1)',
          style({
            height: 0,
            opacity: 0,
            marginTop: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingBottom: 0
          })
        )
      ])
    ]),
    trigger('fadeIn', [
      transition(':enter', [
        style({
          height: 0,
          opacity: 0,
          marginTop: 0,
          marginBottom: 0,
          paddingTop: 0,
          paddingBottom: 0
        }),
        animate(
          '250ms cubic-bezier(0.4, 0, 0.2, 1)',
          style({
            height: '*',
            opacity: 1,
            marginTop: '*',
            marginBottom: '*',
            paddingTop: '*',
            paddingBottom: '*'
          })
        )
      ]),
    ])
  ],
  templateUrl: "./add-stamp.component.html",
  styleUrls: ["./add-stamp.component.scss"],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None
})

export class PassportAddStampComponent {
    private bottomSheet: MatBottomSheet = inject(MatBottomSheet);
    private passportService = inject(PassportService);
    private router = inject(Router);
    public translate = inject(TranslateService);
    public isStamping: WritableSignal<boolean> = signal<boolean>(false);
    public addStampData: WritableSignal<Stamp> = signal<Stamp>(null);
    public currentDevice: MediaDeviceInfo | undefined;
    // Lottie
    // public options: AnimationOptions = { path: '/assets/animations/street-move.json'};

    public toggleStamp(){
        this.isStamping.update(prev => !prev);
        // setTimeout(() => { this.onCodeResultFake('qrFakeString') }, 2000);
    }

    public goToMyPassportsList(){
      this.dismissBottomSheet();
      this.router.navigateByUrl('/my-account/passports')
    }

    public dismissBottomSheet(){
      this.bottomSheet.dismiss();
    }

    //public onCodeResultFake(qrCode: any) {
    //  this.passportService.stampByQrFake(qrCode).subscribe((res: Stamp) => {
    //    this.addStampData.set(res);
    //  })
    //}

    public onCodeResult(qrCode: any) {
      this.passportService.sealByQrCode(qrCode).subscribe((res: any) => {
        console.log("res stamp: ", res);
        this.addStampData.set(res);
      })
    }
  
}
